export const types = {
  authLogin: '[Auth] Login',
  authLogout: '[Auth] Logout',
  authCheckingFinish: '[Auth] Finish checking login state',

  userSetProducts: '[User] Set products',
  userSetProfile: '[User] Set profile',
  userLogout: '[User] Logout',

   userList: '[Users] Load users',
};